<template>
  <div class="storeFeedbackApplicationAdd container">
    <div class="nodeList">
      <el-steps :active="stepsActive" process-status="finish " finish-status="success">
        <el-step :title="item.nodeName" :key="index" v-for="(item, index) in nodeList"></el-step>
      </el-steps>
    </div>
    <el-tag v-if="isStore" type="success" style="margin-bottom:20px;">请餐厅伙伴留意：本系统仅针对产品质量方面问题的反馈。非产品质量问题，如物流配送或产品短保等，请联系配送DC或直送供应商。</el-tag>
    <div class="searchBox">
      <div class="searchBox_top">
        <!--反馈渠道保存，其它按钮都不显示的时候显示-->
        <el-button type="primary" v-acl="FeedbacksUpdateSourceCode" @click="saveSourceCode" v-if="saveSourceCodeBtnShow">{{ $t('common.save') }}</el-button>
        <!--保存-->
        <el-button type="primary" v-acl="FeedbacksSave" @click="saveStoreFeedback" v-if="saveBtnShow">{{
          $t('visitPlan.draftSave') }}</el-button>
        <!--MCD保存-->
        <el-button type="primary" v-acl="FeedbacksMcdSave" @click="saveStoreFeedbackMCD('save')" v-if="saveBtnShowMCD">{{
          $t('common.save') }}</el-button>
        <!--提交-->
        <el-button type="primary" v-acl="FeedbacksSave" @click="submitStoreFeedback" v-if="submitBtnShow">{{
          $t('common.submit') }}</el-button>
        <!--退回-->
        <el-button type="primary" v-acl="FeedbacksFcReturn" @click="returnStoreFeedback" v-if="returnBtnShow">{{
          $t('common.return') }}</el-button>
        <!-- 关闭 -->
        <el-button type="primary" @click="historyBack">关闭</el-button>
        <template v-if="saveBtnShow" v-acl="FeedbacksSave">
          <br />
          <label style="font-size:12px;color:#F56C6C;clear: both">{{ $t('visitPlan.operationTips') }}</label>
        </template>
      </div>
    </div>
    <el-form :model="feedbackData" :label-position="labelPosition" :rules="feedbackRules" ref="feedbackDataForm" label-width="220px">
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item :label="$t('storeFeedback.feedbackNo')" prop="feedbackNo">
            <!--单据编号-->
            <el-input class="handle-input" v-model="feedbackData.feedbackNo" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="110px" :label="$t('storeFeedback.reportType')" prop="reportType">
            <!--类型-->
            <el-input class="handle-input" v-model="feedbackData.reportTypeI18n" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="feedbackData.ttFeedbackId != null">
          <el-form-item label-width="110px" :label="$t('storeFeedback.handleUser')" prop="reportType">
            <!--反馈单处理人-->
            <el-input class="handle-input" v-model="feedbackData.handleUserName" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="20">
          <el-form-item :label="$t('common.remarks')" prop="remark">
            <!--备注-->
            <el-input type="textarea" maxlength="300" autosize class="handle-input" v-model="feedbackData.remark" :disabled="disableEditor"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="20" v-if='feedbackData.suspendReason && feedbackData.suspendReason != " "'>
          <el-form-item :label="$t('storeFeedback.suspendReason')" prop="suspendReason">
            <!--中止原因-->
            <el-input type="textarea" maxlength="300" autosize class="handle-input" v-model="feedbackData.suspendReason" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="feedbackData.returnRemark != null">
        <el-col :span="20">
          <el-form-item label="质量反馈中心初检退回原因" prop="remark">
            <el-input type="textarea" maxlength="300" autosize class="handle-input" v-model="feedbackData.returnRemark" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>餐厅&产品基本信息</span>
        </div>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.createDate')" prop="createDate">
              <!--填表日期-->
              <el-input class="handle-input" v-model="feedbackData.createDate" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.creator')" prop="creator">
              <!--填表人-->
              <el-input class="handle-input" v-model="feedbackData.createName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.creatorTelephone')" prop="tel">
              <!--填表人联系电话-->
              <el-input class="handle-input" v-model="feedbackData.tel" :disabled="disableEditor" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.storeNo')" prop="storeNo">
              <!--餐厅国际编号（7位）-->
              <el-input v-if="isShow" class="handle-input" v-model="feedbackData.storeNo" v-on:change="changeStore" :disabled="disableEditor"></el-input>

              <el-select v-else v-model="feedbackData.storeNo" :disabled="disableEditor" @change="changeStore" :placeholder="$t('common.sel')">
                <el-option v-for="item in storeNoOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.storeName')" prop="storeName">
              <!--餐厅国际名称-->
              <el-input class="handle-input" v-model="feedbackData.storeName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.city')" prop="city">
              <!--质量问题发生的城市-->
              <el-input class="handle-input" v-model="feedbackData.city" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">

            <el-form-item v-if="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.materialCode')" prop="materialCode">
              <!--货号-->
              <el-tooltip class="item" effect="light" content="请查询DC送货单中的货号（8位数字）" placement="top-start">
                <el-input class="handle-input" v-model="feedbackData.materialCode" v-on:change="changeMaterialCode()" :disabled="disableEditor && (!returnBtnShow)"></el-input>
              </el-tooltip>
            </el-form-item>

            <el-form-item v-else :label="$t('storeFeedback.materialCode')" prop="materialCode">
              <!--货号-->
              <el-input class="handle-input" suffix-icon="el-icon-search" @click.native='showSelMaterialDialog = !disableEditor' v-model="feedbackData.materialCode" :disabled="disableEditor">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :required="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.dcName')" prop="dcName">
              <!--发货DC-->
              <ic-select class="handle-input" table="TT_FEEDBACK" field="DIRECT_SUPPLIER" v-model="feedbackData.tmDcId" v-if="isSUPPLIER" :disabled="disableEditor && (!returnBtnShow)"></ic-select>
              <el-input v-else class="handle-input" suffix-icon="el-icon-search" @focus="openDcSelectPage()" v-model="feedbackData.dcName" :disabled="disableEditor && (!returnBtnShow)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.materialName')" prop="materialName">
              <!--产品名称-->
              <el-input class="handle-input" v-model="feedbackData.materialName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.supplier')" prop="supplierName">
              <!--供应商-->
              <el-input class="handle-input" v-model="feedbackData.supplierName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :required="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.receiveDate')" prop="receiveDate">
              <!--餐厅接货日期-->
              <el-date-picker @focus="selectDataBefore('receiveDate')" value-format="yyyy-MM-dd" v-model="feedbackData.receiveDate" type="date" :placeholder="$t('common.selDate')" :disabled="disableEditor"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :required="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.productionDate')" prop="productionDate">
              <!--产品生产日期-->
              <el-date-picker @blur="checkRepeatMethod()" @focus="selectDataBefore('productionDate')" value-format="yyyy-MM-dd" v-model="feedbackData.productionDate" type="date" :placeholder="$t('common.selDate')" :disabled="disableEditor && (!returnBtnShow)"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.expirationDate')" prop="expirationDate">
              <!--产品保质期-->
              <!-- <el-input class="handle-input" v-model="feedbackData.expirationDate" :disabled="disableEditor"></el-input>-->
              <el-date-picker value-format="yyyy-MM-dd" v-model="feedbackData.expirationDate" type="date" :placeholder="$t('common.selDate')" :disabled="disableEditor"></el-date-picker>

            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.lotNumber')" prop="lotNumber">
              <!--生产批号-->
              <el-input class="handle-input" v-model="feedbackData.lotNumber" :disabled="disableEditor"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.feedbackChannel')" prop="sourceCode">
              <!--反馈渠道-->
              <!-- <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="SOURCE_CODE" v-model="feedbackData.sourceCode" :disabled="disableEditor"></ic-select> -->
              <!-- <el-select class="handle-input" filterable @blur="selectBlurSourceCode" v-model="feedbackData.sourceCode" :disabled="disableEditorSuperUser"> -->
              <el-select class="handle-input" @blur="selectBlurSourceCode" v-model="feedbackData.sourceCode" :disabled="disableEditorSourceCode && (!returnBtnShow)">
                <el-option :key="index" v-for="(item, index) in sourceCodeList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.isDirectSale')" prop="isDirectSale">
              <!--是否直营-->
              <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="IS_DIRECT_SALE" v-model="feedbackData.isDirectSale" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.relatedParties')" prop="relatedParties">
              <!--相关方涉及-->
              <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="RELATED_PARTIES" v-model="feedbackData.relatedParties" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.consumeType')" prop="consumeType">
              <!--消费类型-->
              <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="CONSUME_TYPE" v-model="feedbackData.consumeType" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="feedbackData.relatedParties == 'other'" :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.relatedPartiesOther')" prop="relatedPartiesOther">
              <!--相关方涉及其它-->
              <el-input type="textarea" autosize class="handle-input" v-model="feedbackData.relatedPartiesOther" :disabled="disableEditor"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16" v-if="showFcRemarksRow">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.fcRemarks')">
              <el-input type="textarea" autosize class="handle-input" v-model="feedbackData.fcRemarks" :disabled="disableEditorFcRemarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 最终责任方 -->
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item label="最终责任方">
              <IcSelect table='TT_FEEDBACK_REPORT' field='FINAL_RESPONSIBLE_PARTY' v-model="feedbackData.finalResponsibleParty" disabled></IcSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="showFcRemarksRow" type="flex" justify="center">
          <el-button v-if="saveFcRemarksBtnShow" @click="saveFcRemarks" type="primary">{{ $t('common.save') }}</el-button>
        </el-row>

      </el-card>
    </el-form>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>投诉基本信息</span>
      </div>
      <el-form :model="feedbackComplaintData" :label-position="labelPosition" :rules="feedbackComplaintRules" ref="feedbackComplaintDataForm" label-width="160px">
        <!-- <ic-select placeholder="NA" clearable table="TT_FEEDBACK" class="handle-input" field="UNIT" v-model="feedbackComplaintData.productUnit" :disabled="disableEditor"></ic-select> -->
        <el-row :gutter="16">
          <el-col :span="7">
            <el-form-item label="外包装数量" prop="outerPackNum">
              <el-input class="handle-input unit__uom" type="number" v-model="feedbackComplaintData.outerPackNum" :disabled="disableEditor" onkeyup="value=value.replace(/^0+|\\D/g, '').slice(0, 10)">
                <template v-if="outerPackUnitValue" slot="append">{{outerPackUnitValue}}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="内包装数量" prop="innerPackNum" label-width="150px">
              <el-input class="handle-input unit__uom" type="number" v-model="feedbackComplaintData.innerPackNum" :disabled="disableEditor||disableInnerPack" onkeyup="value=value.replace(/^0+|\\D/g, '').slice(0, 10)">
                <template v-if="innerPackUnitValue" slot="append">{{innerPackUnitValue}}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="散货数量" prop="bulkNum" label-width="140px">
              <el-input class="handle-input unit__uom" type="number" v-model="feedbackComplaintData.bulkNum" :disabled="disableEditor" onkeyup="value=value.replace(/^0+|\\D/g, '').slice(0, 10)">
                <template v-if="feedbackComplaintData.bulkUnit" slot="append">{{feedbackComplaintData.bulkUnit}}</template>
              </el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="10">-->
<!--            <el-form-item label="外包装单位" prop="outerPackUnit">-->
<!--              <el-input v-model="outerPackUnitValue" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
<!--        <el-row :gutter="16">-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="内包装数量" prop="innerPackNum">-->
<!--              <el-input class="handle-input" type="number" v-model="feedbackComplaintData.innerPackNum" :disabled="disableEditor||disableInnerPack" onkeyup="value=value.replace(/^0+|\\D/g, '').slice(0, 10)"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="内包装单位" prop="innerPackUnit">-->
<!--              <el-input v-model="innerPackUnitValue" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="16">-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="散货数量" prop="bulkNum">-->
<!--              <el-input class="handle-input" type="number" v-model="feedbackComplaintData.bulkNum" :disabled="disableEditor" onkeyup="value=value.replace(/^0+|\\D/g, '').slice(0, 10)"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="散货单位" prop="bulkUnit">-->
<!--              <el-input v-model="feedbackComplaintData.bulkUnit" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.source')" prop="source">
              <!--选择问题反馈的来源-->
              <ic-select clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="SOURCE" v-model="feedbackComplaintData.source" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :required="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.productStatus')" prop="productStatus">
              <!--问题产品状态-->
              <ic-select placeholder="NA" clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="PRODUCT_STATUS" v-model="feedbackComplaintData.productStatus" :disabled="disableEditor"></ic-select>
              <div class='ccTip'>如涉及异物,务请将其保管在餐厅供后续调查使用</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.ccStore')" prop="cc" :rules="feedbackComplaintRules.cc">
              <!--CC抄送人（门店）-->
              <el-input class="handle-input" v-model="feedbackComplaintData.cc" @blur='feedbackComplaintData.cc = feedbackComplaintData.cc.replace(/\s+/g, "")' :disabled="disableEditor" placeholder="多个邮箱用,或;分割"></el-input>
              <div class='ccTip'>质量反馈单需同时抄送所属的OC、OM、QSC/EHSS经理<br />若有多个邮箱，请用逗号或分号区分</div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :required="feedbackData.reportType == 'STORE'" :label="$t('storeFeedback.haveCompensated')" prop="haveCompensated">
              <!--是否发生用餐者赔偿-->
              <ic-select placeholder="NA" clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="HAVE_COMPENSATED" v-model="feedbackComplaintData.haveCompensated" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.compensateInfo')" prop="compensateInfo">
              <!--赔偿内容-->
              <el-input type="textarea" maxlength="1000" autosize class="handle-input" v-model="feedbackComplaintData.compensateInfo" :disabled="compensateInfoDisable(disableEditor)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('common.remarks')" prop="remark">
              <!--备注-->
              <el-input type="textarea" maxlength="1000" autosize class="handle-input" v-model="feedbackComplaintData.remark" :disabled="disableEditor"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left"></el-divider>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.describeProblem')">
              <!--请详细描述发生问题-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.description')" prop="description" :rules="feedbackData.reportType == 'STORE' ? feedbackComplaintRules.description : feedbackComplaintRules.description2">
              <!--描述-->
              <el-input type="textarea" maxlength="1000" autosize v-model="feedbackComplaintData.description" :disabled="disableEditor"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('common.attachment')">
              <!--附件-->
              <el-table :data="detailDocfileList" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{ scope.row.documentName }}
                    </el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip v-if="!disableEditor" prop="tmDocumentId" min-width="130px">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId, scope.$index, detailDocfileList)">{{
                        $t('common.del') }}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="!disableEditor" ref="upload" action="upload" :http-request="uploadConfirm" :on-remove="detailDocfileRemove" multiple :before-upload="BeforeDetailDoc" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{ $t('common.selectFile') }}</el-button>
                <!--选取文件-->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left"></el-divider>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-tooltip class="item boxPhotoTip" effect="light" content="【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】" placement="top-start">
              <el-form-item :required="reportType == 'STORE'" :label="$t('storeFeedback.boxPhoto')">
                <!--外箱照片（含生产日期）-->
                <el-upload ref="boxPhotoRef" :class="{ hide: disableEditor }" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disableEditor" multiple list-type="picture-card" action="upload" :file-list="boxPhotofileList" :before-upload='beforeBoxPhoto' :http-request="boxPhotoRead">
                  <i class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}" style="height: 100%">
                    <img width='100%' height='100%' :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handleBoxPhotoPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                        <i class="el-icon-download"></i>
                      </span>
                      <span v-if="!disableEditor" class="el-upload-list__item-delete" @click="boxPhotofileRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="boxPhotoDialogVisible" class="enlargePhoto">
                  <img width="100%" :src="boxPhotoImageUrl" alt="">
                </el-dialog>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :required="reportType == 'STORE'" :label="$t('storeFeedback.problemProductPhoto')">
              <!--问题产品照片-->
              <el-upload ref="problemProductPhotoRef" :class="{ hide: disableEditor }" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disableEditor" multiple list-type="picture-card" action="upload" :file-list="problemProductPhotoList" :before-upload='beforeProblemProductPhoto' :http-request="problemProductPhotoRead">
                <i class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}" style="height: 100%">
                  <img width='100%' height='100%' :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handleProblemProductPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                      <i class="el-icon-download"></i>
                    </span>
                    <span v-if="!disableEditor" class="el-upload-list__item-delete" @click="problemProductPhotRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="problemProductDialogVisible" class="enlargePhoto">
                <img width="100%" :src="problemProductImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.otherPhotos')" prop="otherPhotos">
              <!--其他照片-->
              <el-upload ref="otherPhotosRef" :class="{ hide: disableEditor }" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disableEditor" list-type="picture-card" action="upload" :file-list="otherPhotosList" multiple :before-upload='beforeOtherPhoto' :http-request="otherPhotosRead">
                <i class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}" style="height: 100%">
                  <img width='100%' height='100%' :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handleOtherPhotosPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                      <i class="el-icon-download"></i>
                    </span>
                    <span v-if="!disableEditor" class="el-upload-list__item-delete" @click="otherPhotosRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="otherPhotosDialogVisible" class="enlargePhoto">
                <img width="100%" :src="otherPhotosImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.photosDescription')" prop="photosDescription">
              <!--照片要求说明-->
              <el-input type="textarea" maxlength="1000" autosize v-html="feedbackComplaintData.photosDescription" placeholder="" :disabled="disableEditor"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card" v-if="showFirstCheck">
      <div slot="header" class="clearfix">
        <span>问题初检信息</span>
      </div>
      <el-form :model="feedbackFirstCheckData" :label-position="labelPosition" :rules="feedbackFirstCheckRules" ref="feedbackFirstCheckDataForm" label-width="160px">
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.complaintType1')" prop="type1">
              <!--投诉分类1-->
              <el-select @change="changeType1()" class="handle-input" v-model="feedbackFirstCheckData.type1" :disabled="disableEditorFirstCheckMcd">
                <el-option :key="index" v-for="(item, index) in type1List" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.complaintType2')" prop="type2">
              <!--投诉分类2-->
              <el-select class="handle-input" filterable allow-create @ @blur="selectBlurType2" v-model="feedbackFirstCheckData.type2" v-on:change="changeType2(), checkRepeatMethod()" :disabled="disableEditorFirstCheckMcd">
                <el-option :key="index" v-for="(item, index) in type2List" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.complaintType3')" prop="type3">
              <!--投诉分类3-->
              <el-select class="handle-input" filterable allow-create @blur="selectBlurType3" v-model="feedbackFirstCheckData.type3" :disabled="disableEditorFirstCheckMcd">
                <el-option :key="index" v-for="(item, index) in type3List" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.problemLevel')" prop="problemLevel">
              <!--问题等级-->
              <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="PROBLEM_LEVEL" v-model="feedbackFirstCheckData.problemLevel" @change="changeProblemLevel" :disabled="disableEditorFirstCheckMcd"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.deadline')" prop="deadlineValue">
              <!--要求完成时间-->
              <el-input class="handle-input" v-model="feedbackFirstCheckData.deadlineValue" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.isRepeat')" prop="isRepeat">
              <!--是否重复-->
              <el-input class="handle-input" v-model="feedbackFirstCheckData.isRepeat" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.isLto')" prop="isLto">
              <!--是否LTO-->
              <el-select class="handle-input" v-model="feedbackFirstCheckData.isLto" placeholder="请选择" :disabled="disableEditorFirstCheck">
                <el-option v-for="item in isLtoOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.relateType')" prop="relateType">
              <!--相关方判断-->
              <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="RELATE_TYPE" v-model="feedbackFirstCheckData.relateType" v-on:change="changeRelateType()" :disabled="disableEditorFirstCheckMcd"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('storeFeedback.dcName')" prop="firstCheckDcName">
              <!--发货DC-->
              <ic-select class="handle-input" table="TT_FEEDBACK" field="DIRECT_SUPPLIER" v-model="feedbackFirstCheckData.firstCheckDcName" v-if="isSUPPLIER" :disabled="disableEditorFirstCheckMcd" @change="firstCheckDcName"></ic-select>
              <el-input v-else class="handle-input" suffix-icon="el-icon-search" @click.native="openFirstCheckDcSelectPage()" v-model="feedbackFirstCheckData.firstCheckDcName" :disabled="disableEditorFirstCheckMcd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.cc')" prop="cc">
              <!--CC-->
              <el-input class="handle-input" v-model="feedbackFirstCheckData.cc" @blur='feedbackFirstCheckData.cc = feedbackFirstCheckData.cc.replace(/\s+/g, "")' :disabled="disableEditorFirstCheckMcd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="20">
            <el-form-item :label="$t('storeFeedback.mailContent')" prop="mailContent">
              <!--邮件内容-->
              <el-input type="textarea" maxlength="1000" v-model="feedbackFirstCheckData.mailContent" placeholder="" :autosize="{ minRows: 5 }" :disabled="disableEditorFirstCheck"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="showSelDcDialog" append-to-body width="80%">
      <SelDc ref="selectDcRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod" :showStatus='false'></SelDc>
    </el-dialog>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="false" @subCallMethod="selectSupplierMethod" :showStatus='false'></SelSupplier>
    </el-dialog>
    <el-dialog :visible.sync="showFirstCheckSelDcDialog" append-to-body width="80%">
      <SelDc ref="selectDcRef" :multipleSelectionFlag="false" @subCallMethod="selectFirstCheckDcMethod"></SelDc>
    </el-dialog>
    <el-dialog :visible.sync="showFirstCheckSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="false" @subCallMethod="selectFirstCheckSupplierMethod"></SelSupplier>
    </el-dialog>

    <el-dialog :visible.sync="showCqsChangeReasonDialog" width="800px">
      <el-form class="form_border" :label-position="labelPosition" label-width="130px">
        <el-row type="flex" justify="space-around">
          <el-col :span="18">
            <el-form-item required label="CQS变更原因" placeholder="" prop="">
              <!--CQS变更原因-->
              <el-input rows='3' type="textarea" maxlength="100" v-model="cqsChange.cqsChangeRemarks" class="handle-input"></el-input>
              <!-- <ic-select table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="CQS_CHANGE_REASON" v-model="cqsChange.cqsChangeReason"></ic-select> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button style="margin-right: 60px" type="primary" @click="saveStoreFeedbackMCD('submit')">{{
          $t('common.confirm') }}</el-button>
        <el-button type="primary" @click="showCqsChangeReasonDialog = false; cqsChange.cqsChangeRemarks = ''">{{
          $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showCqsChangeReasonDialog1" width="800px">
      <el-form class="form_border" :label-position="labelPosition" label-width="130px">
        <el-row type="flex" justify="space-around">
          <el-col :span="18">
            <el-form-item required label="CQS变更原因" placeholder="" prop="">
              <!--CQS变更原因-->
              <el-input rows='3' type="textarea" maxlength="100" v-model="cqsChange1.cqsChangeRemarks" class="handle-input"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button style="margin-right: 60px" type="primary" @click="saveSourceCode">{{ $t('common.confirm')
        }}</el-button>
        <el-button type="primary" @click="showCqsChangeReasonDialog1 = false; cqsChange1.cqsChangeRemarks = ''">{{
          $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showSelMaterialDialog" append-to-body width="80%">
      <SelMaterial ref="selectMaterialRef" :multipleSelectionFlag="false" @subCallMethod="selectMaterialMethod">
      </SelMaterial>
    </el-dialog>
    <el-dialog title="邮件发送提醒" :visible.sync="emailDialogVisible" width="35%" class="fpa">
      <el-row>
        <el-col>
          <p>当前问题一周内已出现至少三次，属于重复投诉，请选择是否需要发送提醒邮件？</p>
        </el-col>
      </el-row>
      <!-- <el-row type="flex" justify="center" style="margin-top:10px"> -->
      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-col :span="3">重复邮件</el-col>
        <el-col :span="19">
          <el-radio-group v-model="isSendRepeatEmail">
            <el-radio label="Y">发送</el-radio>
            <el-radio label="N">不发送</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-col :span="3">邮件通知范围</el-col>
        <el-col :span="19">
          <el-radio-group v-model="isUpgradeLevel">
            <el-radio label="Y">A类</el-radio>
            <el-radio label="N">非A类</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- </el-row> -->
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="isSend(isSendRepeatEmail,isUpgradeLevel)">确认</el-button>
        <el-button type="primary" @click="emailClose">{{ $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import storeFeedbackApi from "@/api/storeFeedback/storeFeedback";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import PickupUser from "@/components/common/pickupUser";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFun from "@/utils/commonFun";
import SelSupplier from '../base-data/carrier-sel-page'
import SelMaterial from '@/components/page/base-data/material-sel-page'


export default {
  components: { IcSelect, PickupUser, SelDc, SelSupplier, SelMaterial },
  inject: ['reload'],
  data() {
    let changeValidator = (rule, value, callback) => {
      if (value == "") {
        callback(new Error());
      } else {
        callback();
      }
    }

    let validateCC = (rule, value, callback) => {
      if (this.isStore && !value) callback(this.$t("visitPlan.noEmpty"));
      if (value) {
        let arr = value.split(/[,，;；]/);
        var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        let flag = true;
        arr.forEach(item => {
          if (!reg.test(item)) {
            flag = false;
          }
        });
        if (!flag) callback("您填写的邮箱格式不正确，请检查！");
        else {
          callback();
        }
      } else {
        callback();
      }
    }
    let validateDescription = (rule, value, callback) => {
      let _this = this;
      if (_this.reportType == 'STORE' && (_this.feedbackComplaintData.description == null || _this.feedbackComplaintData.description.trim() == '')) {
        callback(new Error(""));
      } else {
        callback();
      }
    }
    let validateDcName = (rule, value, callback) => {
      let _this = this;
      if (_this.saveSubmit != 'save' && _this.reportType != 'FBC' && !_this.feedbackData.tmDcId) {
        callback(new Error(""));
      } else {
        callback();
      }
    }

    let productNumValidator = (rule, value, callback) => {
      let _this = this;
      if (_this.saveSubmit != 'save' && value !== 0 && (value == "" || value == undefined)) {
        callback(new Error(""));
      } else {
        callback();
      }
    }

    let innerPackNumValidator = (rule, value, callback) => {
      let _this = this;
      if (_this.saveSubmit != 'save' && !_this.disableInnerPack && value !== 0 && (value == "" || value == undefined)) {
        callback(new Error(""));
      } else {
        callback();
      }
    }

    

    let receiveDateValidator = (rule, value, callback) => {
      let _this = this;
      if (_this.saveSubmit != 'save' && _this.reportType != 'FBC' && (value == undefined || value.trim() == "")) {
        callback(new Error(""));
      } else {
        callback();
      }
    }

    let validateDc = (rule, value, callback) => {
      let _this = this;
      let relateTypeBl = _this.feedbackFirstCheckData.relateType == 'DC' || _this.feedbackFirstCheckData.relateType == 'SUPPLIER_DC';
      if (_this.saveSubmit == 'submit' && relateTypeBl && (commonFun.isEmpty(_this.feedbackFirstCheckData.firstCheckDcId))) {
        callback(new Error(""));
      } else {
        callback();
      }
    }
    var ccValidator = (rule, value, callback) => {
      if (!value) callback(this.$t("visitPlan.noEmpty"));
      let arr = value.split(/[,，;；]/);
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      let flag = true;
      arr.forEach(item => {
        if (!reg.test(item)) {
          flag = false;
        }
      });
      if (!flag) callback("您填写的邮箱格式不正确，请检查！");
      else {
        callback();
      }
    }
    let validateRelatedPartiesOther = (rule, value, callback) => {
      let _this = this;
      if (_this.feedbackData.relatedParties == 'other' && (value == null || value.trim() == '')) {
        callback(new Error(""));
      } else {
        callback();
      }
    }
    return {
      isShow: true,
      emailDialogVisible: false,
      isSUPPLIER: false,
      isFBC: false,
      isStore: false,
      boxPhotoImageUrl: '',
      problemProductImageUrl: '',
      otherPhotosImageUrl: '',
      boxPhotoDialogVisible: false,
      problemProductDialogVisible: false,
      otherPhotosDialogVisible: false,
      stepsActive: -1,
      isSendRepeatEmail: "Y",
      isUpgradeLevel: "Y",
      storeNoOptions: [],
      nodeList: [],
      detailDocfileList: [],//请详细描述发生问题 的附件
      detailDocfileList2: [],
      // boxPhotofileList: [{name: 'food.jpeg', url: '/adminconsole/file/20200305/4d0e1318e39d4517a764e5205f2bc26b20200305'}],
      boxPhotofileList: [],//外箱生产日期照片
      boxPhotofileList2: [],
      problemProductPhotoList: [],//问题产品照片
      problemProductPhotoList2: [],
      otherPhotosList: [],//其他照片
      otherPhotosList2: [],
      labelPosition: 'right',
      isLtoOptions: [{
        value: 'Y',
        label: this.$t('common.yes')
      }, {
        value: 'N',
        label: this.$t('common.no')
      }],
      type1List: [],
      allType2List: [],
      allType3List: [],
      type2List: [],
      type3List: [],
      allSourceCodeList: [],
      sourceCodeList: [],
      ttFeedbackId: '',
      showSelDcDialog: false,
      showFirstCheckSelDcDialog: false,
      showFirstCheckSelSupplierDialog: false,
      showSelSupplierDialog: false,
      showFirstCheck: true,
      feedbackData: {
        sourceCode: "STORE"
      },
      feedbackComplaintData: {},
      feedbackFirstCheckData: {},
      disableEditor: true,
      disableEditorSourceCode: true,//控制反馈渠道是否可编辑
      disableEditorFirstCheck: true,
      disableEditorFirstCheckMcd: true,
      disableEditorSuperUser: true,//控制反馈渠道是否可编辑
      disableInnerPack: false,
      saveBtnShow: false,
      saveBtnShowMCD: false,
      submitBtnShow: false,
      returnBtnShow: false,
      saveSourceCodeBtnShow: false,
      reportType: '',//报告创建方FBC,STORE
      saveSubmit: '',
      cqsChange: {
        // cqsChangeReason:"",//变更原因
        cqsChangeRemarks: ""//变更备注
      },

      cqsChange1: {
        // cqsChangeReason:"",//变更原因
        cqsChangeRemarks: ""//变更备注
      },
      showCqsChangeReasonDialog: false,
      showCqsChangeReasonDialog1: false,
      oldFirstCheckType: '',
      showSelMaterialDialog: false,
      canMcdEdit: false,
      haveFeedbacksUpdateSourceCode: false,//是否有反馈渠道编辑权限
      oldSourceCode: "",
      showFcRemarksRow: false,
      disableEditorFcRemarks: true,//控制质量反馈中心备注是否可编辑
      saveFcRemarksBtnShow: false,
      haveFeedbacksUpdateFcRemarks: false,//是否有编辑质量反馈中心备注的权限,只对初检后的单据控制
      outerPackUnitValue: "",
      innerPackUnitValue: "",
      icMap: {},
      feedbackRules: {
        tel: [
          //填表人联系电话不能为空
          { required: true, message: this.$t('storeFeedback.creatorTelephone') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        storeNo: [
          //餐厅国际编号（7位）不能为空
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        storeName: [
          //餐厅国际编号（7位）不存在
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.doesNotExist'), trigger: 'blur' },
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.doesNotExist'), validator: changeValidator, trigger: 'change' }
        ],
        dcName: [
          //发货DC不能为空
          { validator: validateDcName, message: this.$t('storeFeedback.dcName') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
          //  { required: true,  message:'发货DC不能为空', trigger: 'blur' }
        ],
        materialCode: [
          //货号不能为空
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        materialName: [
          //货号不存在
          { required: true, message: '产品名称不能为空', validator: changeValidator, trigger: 'dbBlur' }
        ],
        supplierName: [
          { required: true, message: '供应商不能为空', validator: changeValidator, trigger: 'dbBlur' }
        ],
        receiveDate: [
          //请选择餐厅接货日期
          { message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.receiveDate'), validator: receiveDateValidator, trigger: 'blur' }
        ],
        productionDate: [
          //请选择产品生产日期
          { message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productionDate'), validator: receiveDateValidator, trigger: 'blur' }
        ],
        expirationDate: [
          //请选择产品保质期
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.expirationDate'), trigger: 'blur' }
        ],

        feedbackChannel: [
          //请选择反馈渠道
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.feedbackChannel'), trigger: 'change' }
        ],
        isDirectSale: [
          //请选择是否直营
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isDirectSale'), trigger: 'blur' },
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isDirectSale'), validator: changeValidator, trigger: 'change' }
        ],
        consumeType: [
          //请选择消费类型
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.consumeType'), trigger: 'blur' },
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.consumeType'), validator: changeValidator, trigger: 'change' }
        ],
        relatedParties: [
          //请选择相关方涉及
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.relatedParties'), trigger: 'blur' },
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.relatedParties'), validator: changeValidator, trigger: 'change' }
        ],
        sourceCode: [
          { required: true, message: '请选择反馈渠道', trigger: 'blur' }
        ],
        relatedPartiesOther: [
          { required: true, validator: validateRelatedPartiesOther, message: '相关方涉及其他不能为空', trigger: 'blur' }
        ]
      },
      feedbackComplaintRules: {
        cc: [{ required: true, validator: validateCC, trigger: 'blur' },],
        outerPackNum: [
          //外包装产品数量不能为空
          { required: true, message: this.$t('storeFeedback.productNum') + this.$t('common.canNotBeEmpty'), validator: productNumValidator, trigger: 'blur' }
        ],
        innerPackNum: [
          //内包装产品数量不能为空
          { required: !this.disableInnerPack, message: this.$t('storeFeedback.productNum') + this.$t('common.canNotBeEmpty'), validator: innerPackNumValidator, trigger: 'blur' }
        ],
        bulkNum: [
          //散货数量不能为空
          { required: true, message: this.$t('storeFeedback.productNum') + this.$t('common.canNotBeEmpty'), validator: productNumValidator, trigger: 'blur' }
        ],
        productNum: [
          //问题产品数量不能为空
          { required: true, message: this.$t('storeFeedback.productNum') + this.$t('common.canNotBeEmpty'), validator: productNumValidator, trigger: 'blur' }
        ],
        productNum2: [
          { required: false }
        ],
        productUnit: [
          //请选择问题产品数量单位
          { message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productUnit'), validator: productNumValidator, trigger: 'change' }
        ],

        // source: [
        //   //请选择问题反馈的来源
        //   { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.source'), trigger: 'change' }
        // ],
        productStatus: [
          //请选择问题产品状态
          { message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productStatus'), validator: productNumValidator, trigger: 'change' }
        ],
        haveCompensated: [
          //请选择是否发生用餐者赔偿
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.haveCompensated'), trigger: 'change' }
        ],
        description: [
          //描述不能为空
          { required: true, validator: validateDescription, message: this.$t('storeFeedback.description') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        description2: [
          { required: false }
        ],

      },
      feedbackFirstCheckRules: {
        type1: [
          //请选择投诉分类1
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.complaintType1'), trigger: 'change' }
        ],
        type2: [
          //请选择投诉分类2
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.complaintType2'), trigger: 'change' }
        ],
        type3: [
          //请选择投诉分类2
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.complaintType3'), trigger: 'change' }
        ],
        problemLevel: [
          //请选择问题等级
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.problemLevel'), trigger: 'change' }
        ],
        isLto: [
          //请选择是否LTO
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isLto'), trigger: 'dbClick' }
        ],
        relateType: [
          //请选择相关方判断
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.relateType'), trigger: 'change' }
        ],
        mailContent: [
          //邮件内容不能为空
          { required: true, message: '邮件内容不能为空', trigger: 'dbClick' }
        ],
        cc: [
          { validator: validateCC, trigger: "blur" }
        ],
        firstCheckDcName: [
          { validator: validateDc, message: "发货DC不能为空", trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    console.log("GY🚀 ~ file: storeFeedbackDetail.vue:975 ~ created ~ roles:", roles);
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
      }
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
    }
    if ((roles.includes('SF_STORE_BASIC') && !roles.includes('SF_FBC_BASIC') && !roles.includes('SF_MCD_BASIC') && !roles.includes('SF_SUP_BASIC'))) {
      this.isShow = false//显示下拉框
    } else {
      this.isShow = true//显示输入框
    }
    console.log("GY🚀 ~ file: storeFeedbackDetail.vue:981 ~ created ~ this.isShow:", this.isShow);
    this.ttFeedbackId = this.$route.query.feedbackId;
    this.storeFeedbackPageInitM(this.$route.query.feedbackId);
  },
  created() {
    this.getInputChoiceValues();
  },
  methods: {
    storeFeedbackPageInitM(param) {
      let _this = this;
      _this.haveFeedbacksUpdateSourceCode = commonFun.havePermission("FeedbacksUpdateSourceCode");
      storeFeedbackApi.getDetail(param).then((res) => {
        _this.type1List = res.data.inputChoice["TT_FEEDBACK_FIRST_CHECK:TYPE1"];
        _this.allType2List = res.data.inputChoice["TT_FEEDBACK_FIRST_CHECK:TYPE2"];
        _this.allType3List = res.data.inputChoice["TT_FEEDBACK_FIRST_CHECK:TYPE3"];
        _this.allSourceCodeList = res.data.inputChoice["TT_FEEDBACK:SOURCE_CODE"];

        if (res.data.feedback.storeNos && res.data.feedback.storeNos.length > 0) {
          res.data.feedback.storeNos.map((v) => {
            _this.storeNoOptions.push({
              value: v,
              label: v
            })
          })
        }

        _this.feedbackData = res.data.feedback;
        _this.oldSourceCode = res.data.feedback.sourceCode;
        if (!_this.feedbackData.dcName) {
          _this.feedbackData.dcName = " ";//特殊处理
        }
        if (!_this.feedbackData.productionDate) {
          _this.feedbackData.productionDate = " ";//特殊处理
        }
        if (!_this.feedbackData.receiveDate) {
          _this.feedbackData.receiveDate = " ";//特殊处理
        }

        //判断反馈渠道是否在正常列表中
        _this.sourceCodeList = [];
        _this.sourceCodeList = _this.allSourceCodeList;
        if (_this.feedbackData.sourceCode != null && _this.feedbackData.sourceCode != '') {
          let exists = false;
          _this.allSourceCodeList.forEach(function (val) {
            if (val.code == _this.feedbackData.sourceCode) {
              exists = true;
            }
          });
          if (!exists) {
            let newIc = { code: _this.feedbackData.sourceCode, chineseValue: _this.feedbackData.sourceCode, englishValue: _this.feedbackData.sourceCode }
            _this.sourceCodeList.push(newIc)
          }
        } else {
          _this.feedbackData.sourceCode = 'STORE' //默认门店
        }
        _this.reportType = res.data.feedback.reportType;
        _this.feedbackComplaintData = res.data.feedbackComplaint == null ? { compensateInfo: null, haveCompensated: null } : res.data.feedbackComplaint;
        if (_this.reportType == 'FBC') {
          _this.feedbackComplaintData.photosDescription = "* 照片提供：请餐厅随本反馈单提供" +
            "<br\/>*【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】" +
            "<br\/>*问题产品照片（请留存样品）";
        } else {
          _this.feedbackComplaintData.photosDescription = "* 照片提供：请餐厅随本反馈单提供" +
            "<br\/>*<font>【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】</font>" +
            "<br\/>*有问题的产品请务必留存;";
        }

        if (_this.feedbackData.materialCode) {
          this.retrieveInOutPackUnit(_this.feedbackData.materialCode);
        }

        //判断是否带出IS_LTO值
        let ltoValue = res.data.feedbackFirstCheck == null ? null : res.data.feedbackFirstCheck.isLto;
        //如果是门店创建，反馈中心初检，并且isLto值为空
        if (_this.reportType == 'STORE' && _this.feedbackData.status == 'submit' && (res.data.feedbackFirstCheck == null || res.data.feedbackFirstCheck.isLto == null)) {
          ltoValue = _this.feedbackData.isLto;
          if (res.data.feedbackFirstCheck != null) {
            res.data.feedbackFirstCheck.isLto = ltoValue;
          }
        }
        if (!!res.data.feedbackFirstCheck) {
          let fc = res.data.feedbackFirstCheck;
          //分类1，2，3，问题等级，相关方+反馈渠道
          _this.oldFirstCheckType = fc.type1 + fc.type2 + fc.type3 + fc.type2 + fc.problemLevel + fc.relateType + _this.feedbackData.sourceCode + fc.firstCheckDcId + fc.cc;
        }
        //反馈新增的单据,草稿状态
        if (_this.reportType == 'FBC' && _this.feedbackData.status == 'draft') {
          if (null != _this.feedbackData.isLto && null == ltoValue) {
            ltoValue = _this.feedbackData.isLto;
          }
        }
        _this.feedbackFirstCheckData = res.data.feedbackFirstCheck == null ? { isRepeat: '', mailContent: null, cc: null, isLto: ltoValue } : res.data.feedbackFirstCheck;
        _this.feedbackFirstCheckData.mailA = res.data.mailA;
        _this.feedbackFirstCheckData.mailB = res.data.mailB;
        _this.feedbackFirstCheckData.mailC = res.data.mailC;

        if (_this.feedbackFirstCheckData.deadline != null) {
          _this.feedbackFirstCheckData.deadlineValue = _this.feedbackFirstCheckData.deadline + this.$t('storeFeedback.hours');
        }
        this.getType2Option();
        this.getType3Option();
        _this.showFirstCheck = (res.data.fbcUser || res.data.mcdUser || res.data.supUser);
        if (res.data.canEdit) {
          _this.disableEditorSuperUser = false;
          _this.disableEditor = false;
          _this.disableEditorFirstCheck = false;
          _this.disableEditorFirstCheckMcd = false;
          _this.saveBtnShow = true;
          _this.submitBtnShow = true;
        }
        _this.canMcdEdit = res.data.canMcdEdit;
        if (res.data.canMcdEdit) {
          _this.saveBtnShowMCD = true;
          _this.disableEditorFirstCheckMcd = false;
          _this.disableEditorSuperUser = false;
        }
        if (res.data.canAudit) {
          _this.disableEditorFirstCheck = false;
          _this.disableEditorFirstCheckMcd = false;
          _this.saveBtnShow = true;
          _this.submitBtnShow = true;
          _this.returnBtnShow = true;
        }
        if (res.data.detailDoc != null) {
          if (res.data.detailDoc.length > 0) {
            _this.detailDocfileList = res.data.detailDoc
          }
        }
        if (res.data.foreignPic != null) {
          if (res.data.foreignPic.length > 0) {
            let foreignPic = res.data.foreignPic
            var temp = foreignPic.map(function (item) {
              let obj = {
                name: item["documentName"],
                url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
                documentName: item["documentName"],
                downloadType: item["downloadType"],
                tmDocumentId: item["tmDocumentId"]
              };
              return obj;
            });
            _this.boxPhotofileList = temp
            _this.boxPhotofileList2 = res.data.foreignPic
          }
        }
        if (res.data.questionPic != null) {
          if (res.data.questionPic.length > 0) {
            let questionPic = res.data.questionPic
            var temp = questionPic.map(function (item) {
              let obj = {
                name: item["documentName"],
                url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
                documentName: item["documentName"],
                downloadType: item["downloadType"],
                tmDocumentId: item["tmDocumentId"]
              };
              return obj;
            });
            _this.problemProductPhotoList = temp
            _this.problemProductPhotoList2 = res.data.questionPic
          }
        }
        if (res.data.otherPic != null) {
          if (res.data.otherPic.length > 0) {
            let otherPic = res.data.otherPic
            var temp = otherPic.map(function (item) {
              let obj = {
                name: item["documentName"],
                url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
                documentName: item["documentName"],
                downloadType: item["downloadType"],
                tmDocumentId: item["tmDocumentId"]
              };
              return obj;
            });
            _this.otherPhotosList = temp
            _this.otherPhotosList2 = res.data.otherPic
          }
        }
        let nodeList = res.data.nodeList
        if (nodeList) {
          for (let i = 0, len = nodeList.length; i < len; i++) {
            if (nodeList[i].status == 'current') {
              this.stepsActive = i;
            }
          }
          if (_this.stepsActive == -1) {//没有等于current的 说明终止了
            this.$refs.feedbackFirstCheckDataForm.resetFields();
            // this.$refs.feedbackDataForm.resetFields();
            this.$refs.feedbackComplaintDataForm.resetFields();

          }
        }
        this.nodeList = nodeList
        this.$refs.feedbackFirstCheckDataForm.resetFields();
        // this.changeMaterialCode2();
        //如果等于草稿，提交，退回则计算是否重复
        if (_this.showFirstCheck && (['lowerHair', 'suspend'].indexOf(_this.feedbackData.status) < 0)) {
          _this.checkRepeatMethod();
        }

        //反馈渠道是否可编辑,控制反馈渠道保存按钮是否显示
        let workflowStatusValue = _this.feedbackData.workflowStatus;
        let workflowStatusArr = ["supplierSurvey", "mcdApproval", "fbcConfirm", "surveyEnd", "communicate", "finalSettlement"];
        if (!_this.disableEditor) {
          _this.disableEditorSourceCode = false;
        } else if (_this.haveFeedbacksUpdateSourceCode && workflowStatusArr.indexOf(workflowStatusValue) != -1) {//有权限
          _this.disableEditorSourceCode = false;
        }
        _this.saveSourceCodeBtnShow = !(_this.saveBtnShow || _this.saveBtnShowMCD || _this.submitBtnShow || _this.returnBtnShow);
        //判断质量反馈中心备注的显示与可编辑
        if (_this.feedbackData.reportType == 'STORE') {//门店创建的问题报告
          if (_this.isStore) {//门店用户
            if (_this.feedbackData.status == 'lowerHair' || _this.feedbackData.status == 'suspend') {
              _this.showFcRemarksRow = true;
            }
          } else {//非门店用户
            _this.showFcRemarksRow = true;
            if (_this.isFBC && _this.feedbackData.status == 'submit') {//反馈中心用户进行初检操作
              _this.disableEditorFcRemarks = false;//可编辑
            }
            if (_this.feedbackData.status != 'submit') {
              _this.haveFeedbacksUpdateFcRemarks = commonFun.havePermission("FeedbacksUpdateFcRemarks");
              if (_this.haveFeedbacksUpdateFcRemarks) {//有编辑权限
                _this.disableEditorFcRemarks = false;//可编辑
                _this.saveFcRemarksBtnShow = true;//保存按钮显示
              }
            }
          }
        } else {//反馈中心创建的
          _this.haveFeedbacksUpdateFcRemarks = commonFun.havePermission("FeedbacksUpdateFcRemarks");
          if (_this.isStore) {//门店用户
            if (_this.feedbackData.status == 'lowerHair' || _this.feedbackData.status == 'suspend') {
              _this.showFcRemarksRow = true;
            }
          } else {
            _this.showFcRemarksRow = true;
            if (_this.isFBC && (_this.feedbackData.status == 'draft' || _this.haveFeedbacksUpdateFcRemarks)) {//反馈中心用户进行初检操作
              _this.disableEditorFcRemarks = false;//可编辑
              if (_this.haveFeedbacksUpdateFcRemarks) {
                _this.saveFcRemarksBtnShow = true;//保存按钮显示
              }
            } else if (_this.feedbackData.status != 'draft' && _this.haveFeedbacksUpdateFcRemarks) {
              _this.disableEditorFcRemarks = false;//可编辑
              _this.saveFcRemarksBtnShow = true;//保存按钮显示
            }
          }
        }
      });
    },
    historyBack: function () {
      this.$router.push({//返回列表
        name: `feedback`,
      })
    },
    openDcSelectPage: function () {
      let that = this;
      if (this.disableEditor && (!this.returnBtnShow)) {
        return;
      }
      if (commonFun.isEmpty(that.feedbackData.materialCode)) {
        that.$message({ message: "请填写货号", type: "warning" });
        return;
      } else {
        storeFeedbackApi.getMaterialInfo(that.feedbackData.materialCode).then((res) => {
          if (res.meta.success) {
            //发货DC数据源选择是根据八位码对应的配送类型带出，如果是非直送选择DC主数据，直送选择直送三家供应商 ： 14-009,39-002,38-008（下拉列表选择）
            // let disType = 'SUPPLIER'
            let disType = res.data.disType
            if (disType == 'SUPPLIER') {
              //从承运商中选择
              // this.showSelSupplierDialog = true;
              this.isSUPPLIER = true
            } else {
              //从DC中选择
              this.showSelDcDialog = true;
              this.isSUPPLIER = false;
            }
          } else {
            Message({ message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), type: "warning" });
          }
        })
      }
      // if(this.feedbackData.isDirectSale=='Y'){
      //     //从承运商中选择
      //     this.showSelSupplierDialog = true;
      // }else{
      //     //从DC中选择
      //     this.showSelDcDialog = true;
      // }
    },
    firstCheckDcName(e) {
      this.feedbackFirstCheckData.firstCheckDcId = e;
    },
    openFirstCheckDcSelectPage: function () {
      if (this.disableEditorFirstCheckMcd) {
        return;
      }
      this.showFirstCheckSelDcDialog = true;
    },
    selectDcMethod: function (dcList) {
      this.feedbackFirstCheckData.firstCheckDcName = dcList[0].dcName;
      this.feedbackFirstCheckData.firstCheckDcId = dcList[0].tmDcId;
      this.feedbackData.dcName = dcList[0].dcName;
      this.feedbackData.tmDcId = dcList[0].tmDcId;
      this.showSelDcDialog = false;
    },
    selectSupplierMethod: function (supList) {
      this.feedbackData.dcName = supList[0].supplierName;
      this.feedbackData.tmDcId = supList[0].tmSupplierId;
      this.showSelSupplierDialog = false;
    },
    selectFirstCheckDcMethod: function (dcList) {
      this.feedbackFirstCheckData.firstCheckDcName = dcList[0].dcName;
      this.feedbackFirstCheckData.firstCheckDcId = dcList[0].tmDcId;
      this.feedbackData.dcName = dcList[0].dcName
      this.feedbackData.tmDcId = dcList[0].tmDcId
      this.showFirstCheckSelDcDialog = false;
    },
    selectFirstCheckSupplierMethod: function (supList) {
      this.feedbackFirstCheckData.firstCheckDcName = supList[0].supplierName;
      this.feedbackFirstCheckData.firstCheckDcId = supList[0].tmSupplierId;
      this.showFirstCheckSelSupplierDialog = false;
    },
    //详情描述上传 之前
    BeforeDetailDoc(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isPng = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isBMP = file.type === "image/bmp";
      // accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
      if (isJPG || isPng || isJPEG || isGIF || isBMP) {
        _this.$message.error("不可以上传图片");
        return false;
      }
      if(file.name&&file.name.length>100) {
        _this.$message.error("附件名称过长，请修改后再传");
        return false;
      }
    },
    //详情描述上传文件
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.detailDocfileList2.push(res.data[0])
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //详情描述文件删除
    detailDocfileRemove(file) {
      for (let j = 0; j < this.detailDocfileList2.length; j++) {
        if (this.detailDocfileList2[j].documentName == file.name) {
          this.detailDocfileList2.splice(j, 1)
        }
      }
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    //外箱照片（含生产日期）上传前
    beforeBoxPhoto(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isPng = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isBMP = file.type === "image/bmp";
      if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
        this.$message.error("只能上传图片");
        return false
      }
      if(file.name&&file.name.length>100) {
        this.$message.error("附件名称过长，请修改后再传");
        return false
      }
    },
    //外箱照片（含生产日期）上传
    boxPhotoRead(file) {
      console.log("GY🚀 ~ boxPhotoRead ~ file:", file);
      let formData = new FormData();
      formData.append("file", file.file);
      fileService.fileUpload(formData).then((res) => {
        console.log("GY🚀 ~ fileService.fileUpload ~ res:", res);
        this.boxPhotofileList2.push(...res.data);
      }).catch((error) => { });
      console.log("GY🚀 ~ fileService.fileUpload ~ this.boxPhotofileList2:", this.boxPhotofileList2);
    },
    //外箱照片（含生产日期）删除
    boxPhotofileRemove(file) {
      for (let j = 0; j < this.boxPhotofileList2.length; j++) {
        if (this.boxPhotofileList2[j].documentName == file.name) {
          this.boxPhotofileList2.splice(j, 1)
        }
      }
      let allFile = this.$refs.boxPhotoRef.$data.uploadFiles;
      this.removeTempFile(allFile, file);
    },
    /**
     * 删除页面缩略图
     * @param files
     * @param delFile
     */
    removeTempFile: function (files, delFile) {
      if (!!files) {
        for (let j = 0; j < files.length; j++) {
          if (files[j].name == delFile.name) {
            files.splice(j, 1)
          }
        }
      }
    },
    //问题产品照片上传前
    beforeProblemProductPhoto(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isPng = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isBMP = file.type === "image/bmp";
      if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
        this.$message.error("只能上传图片");
        return false
      }
      if(file.name&&file.name.length>100) {
        this.$message.error("附件名称过长，请修改后再传");
        return false
      }
    },
    //问题产品照片上传
    problemProductPhotoRead(file) {
      console.log("GY🚀 ~ problemProductPhotoRead ~ file:", file);
      let formData = new FormData();
      formData.append("file", file.file);
      fileService.fileUpload(formData).then((res) => {
        this.problemProductPhotoList2.push(...res.data);
      }).catch((error) => { });
    },
    //问题产品照片删除
    problemProductPhotRemove(file) {
      for (let j = 0; j < this.problemProductPhotoList2.length; j++) {
        if (this.problemProductPhotoList2[j].documentName == file.name) {
          this.problemProductPhotoList2.splice(j, 1)
        }
      }
      let allFile = this.$refs.problemProductPhotoRef.$data.uploadFiles;
      this.removeTempFile(allFile, file);
    },
    //其他照片 上传前
    beforeOtherPhoto(file) {
      let _this = this;
      const isJPG = file.type === "image/jpg";
      const isPng = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isBMP = file.type === "image/bmp";
      if (!isJPG && !isPng && !isJPEG && !isGIF && !isBMP) {
        this.$message.error("只能上传图片");
        return false
      }
      if(file.name&&file.name.length>100) {
        this.$message.error("附件名称过长，请修改后再传");
        return false
      }
    },
    //其他照片上传
    otherPhotosRead(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      fileService.fileUpload(formData).then((res) => {
        this.otherPhotosList2.push(...res.data);
      }).catch((error) => { });
    },
    //其他照片删除
    otherPhotosRemove(file) {
      for (let j = 0; j < this.otherPhotosList2.length; j++) {
        if (this.otherPhotosList2[j].documentName == file.name) {
          this.otherPhotosList2.splice(j, 1)
        }
      }
      let allFile = this.$refs.otherPhotosRef.$data.uploadFiles;
      this.removeTempFile(allFile, file);
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    changeStore: function () {
      let _this = this;
      if (_this.feedbackData.storeNo == null || _this.feedbackData.storeNo == "") {
        return;
      }
      if (_this.feedbackData.storeNo == '9999999' && _this.isFBC) {
        //餐厅编号允许输入9999999虚拟的餐厅编号，餐厅国际名称也是9999999，问题发生城市默认dumycity，是否直营默认为是
        _this.feedbackData.storeName = '9999999'
        _this.feedbackData.city = 'dummycity'
        _this.feedbackData.isDirectSale = 'Y'
        return;
      }
      storeFeedbackApi.getStoreInfo(_this.feedbackData.storeNo).then((res) => {
        if (res.meta.success) {
          this.feedbackData.storeName = res.data.storeName;
          this.feedbackData.city = res.data.storeCity;
          this.feedbackData.isDirectSale = res.data.isDirect;
        } else {
          Message({ message: this.$t('storeFeedback.storeNo') + this.$t('common.doesNotExist'), type: "warning" });
          _this.feedbackData.storeNo = null;
          _this.feedbackData.storeName = null;
          _this.feedbackData.city = null;
          _this.feedbackData.isDirectSale = null;
        }

      }).catch((error) => {
        _this.feedbackData.storeNo = null;
        //文件上传失败
      });
    },
    changeIsDirectSale: function (val) {
      //是否直营改变后必须重新选择发货DC
      this.feedbackData.dcName = ' ';
      this.feedbackData.tmDcId = null;
    },
    changeMaterialCode: function () {
      let _this = this;
      if (this.feedbackData.materialCode) {
        storeFeedbackApi.getMaterialInfo(this.feedbackData.materialCode, {needFormal: true}).then((res) => {
          if (res.meta.success) {
            this.feedbackData.materialName = res.data.eightBitCodeName;
            this.feedbackData.materialCode = res.data.eightBitCode;
            this.feedbackData.supplierName = res.data.plantName
            this.feedbackData.tmSupplierId = res.data.tmPlantId
            this.feedbackData.dcName = ' '
            this.feedbackData.tmDcId = ''
            this.feedbackFirstCheckData.firstCheckDcId = ''
            this.feedbackFirstCheckData.firstCheckDcName = ''
            this.feedbackComplaintData.outerPackUnit = '';
            this.feedbackComplaintData.innerPackUnit = '';
            this.feedbackComplaintData.bulkUnit = '';
            if (res.data.disType == 'SUPPLIER') {
              this.isSUPPLIER = true;
            } else {
              this.isSUPPLIER = false;
            }
            if (_this.feedbackData.reportType == 'FBC') {
              _this.feedbackFirstCheckData.isLto = res.data.isLto;
            }
            this.renderInOutPackUnit(res.data);
          } else {
            this.feedbackData.materialName = ''
            this.feedbackData.supplierName = ''
            this.feedbackData.dcName = ' '
            this.feedbackData.tmDcId = ''
            this.isSUPPLIER = false
            this.feedbackData.tmSupplierId = null
            this.feedbackComplaintData.outerPackUnit = '';
            this.feedbackComplaintData.innerPackUnit = '';
            this.feedbackComplaintData.bulkUnit = '';
            this.outerPackUnitValue = '';
            this.innerPackUnitValue = '';            
            Message({ message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), type: "warning" });
          }
        })
      } else {
        this.feedbackData.materialName = ''
        this.feedbackData.supplierName = ''
        this.feedbackData.dcName = ' '
        this.feedbackData.tmDcId = ''
        this.isSUPPLIER = false
        this.feedbackData.tmSupplierId = null
        this.feedbackFirstCheckData.firstCheckDcId = ''
        this.feedbackFirstCheckData.firstCheckDcName = ''
        this.feedbackComplaintData.outerPackUnit = '';
        this.feedbackComplaintData.innerPackUnit = '';
        this.feedbackComplaintData.bulkUnit = '';
        this.outerPackUnitValue = '';
        this.innerPackUnitValue = '';        
      }
    },
    // changeMaterialCode2: function(){
    //     let _this = this;
    //     if(this.feedbackData.materialCode){
    //         storeFeedbackApi.getMaterialInfo(this.feedbackData.materialCode).then((res)=>{
    //             if(res.meta.success){
    //                 this.feedbackData.materialName = res.data.eightBitCodeName;
    //                 this.feedbackData.supplierName = res.data.plantName
    //                 this.feedbackData.tmSupplierId = res.data.tmPlantId
    //                 if (res.data.disType == 'SUPPLIER') {
    //                     this.isSUPPLIER = true;
    //                 }else {
    //                     this.isSUPPLIER = false;
    //                 }
    //             } else {
    //                 this.feedbackData.materialName = ''
    //                 this.feedbackData.supplierName = ''
    //                 this.feedbackData.dcName = ' '
    //                 this.feedbackData.tmDcId = ''
    //                 this.isSUPPLIER = false
    //                 this.feedbackData.tmSupplierId = null
    //                 Message({message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), type: "warning"});
    //             }
    //         })
    //     }else{
    //         this.feedbackData.materialName = ''
    //         this.feedbackData.supplierName = ''
    //         this.feedbackData.dcName = ' '
    //         this.feedbackData.tmDcId = ''
    //         this.isSUPPLIER = false
    //         this.feedbackData.tmSupplierId = null
    //     }

    // },
    changeRelateType: function () {
      if (this.feedbackFirstCheckData.relateType == 'SUPPLIER') {
        this.feedbackFirstCheckData.firstCheckDcId = null;
        this.feedbackFirstCheckData.firstCheckDcName = "";
      } else if (this.feedbackFirstCheckData.relateType == 'DC' || this.feedbackFirstCheckData.relateType == 'SUPPLIER_DC') {
        this.feedbackFirstCheckData.firstCheckDcId = this.feedbackData.tmDcId;
        this.feedbackFirstCheckData.firstCheckDcName = this.feedbackData.dcName;
      }
    },
    changeProblemLevel: function () {
      if (this.feedbackFirstCheckData.problemLevel == 'A') {
        this.feedbackFirstCheckData.deadline = "24";
        this.feedbackFirstCheckData.deadlineValue = "24" + this.$t('storeFeedback.hours');
        /*if(!this.saveBtnShowMCD){}*/
        this.feedbackFirstCheckData.mailContent = this.feedbackFirstCheckData.mailA;

      } else if (this.feedbackFirstCheckData.problemLevel == 'B') {
        this.feedbackFirstCheckData.deadline = 24 * 3 + "";
        this.feedbackFirstCheckData.deadlineValue = this.feedbackFirstCheckData.deadline + this.$t('storeFeedback.hours');
        /*if(!this.saveBtnShowMCD){}*/
        this.feedbackFirstCheckData.mailContent = this.feedbackFirstCheckData.mailB;

      } else if (this.feedbackFirstCheckData.problemLevel == 'C') {
        this.feedbackFirstCheckData.deadline = 24 * 5 + "";
        this.feedbackFirstCheckData.deadlineValue = this.feedbackFirstCheckData.deadline + this.$t('storeFeedback.hours');
        /*if(!this.saveBtnShowMCD){}*/
        this.feedbackFirstCheckData.mailContent = this.feedbackFirstCheckData.mailC;

      }
    },
    changeType1: function () {
      let _this = this;
      _this.type2List = [];
      _this.$set(this.feedbackFirstCheckData, 'type2', null);
      _this.$set(this.feedbackFirstCheckData, 'type3', null);
      _this.getType2Option();
      _this.type1List.forEach(function (val) {
        if (val.code == _this.feedbackFirstCheckData.type1) {
          _this.feedbackFirstCheckData.problemLevel = val.restrictFieldValue1;
          _this.changeProblemLevel();
        }
      });
    },
    changeType2: function (method) {
      this.type3List = [];
      this.$set(this.feedbackFirstCheckData, 'type3', null);
      this.getType3Option();
    },
    getType2Option: function () {
      let _this = this;
      if (_this.feedbackFirstCheckData.type1 != null) {
        let newType2 = [];
        let type2Value = _this.feedbackFirstCheckData.type2;
        let existsFlag = false;
        _this.allType2List.forEach(function (val) {
          if (val.restrictFieldValue1 == _this.feedbackFirstCheckData.type1) {
            newType2.push(val);
            if (type2Value != null && type2Value == val.code) {
              existsFlag = true;
            }
          }
        });
        if (!existsFlag && type2Value != null) {
          let newIc = { code: type2Value, chineseValue: type2Value, englishValue: type2Value }
          newType2.push(newIc);
        }
        _this.type2List = newType2;
      }
    },
    getType3Option: function () {
      let _this = this;
      if (_this.feedbackFirstCheckData.type2 != null) {
        let newType3 = [];
        let type3Value = _this.feedbackFirstCheckData.type3;
        let existsFlag = false;
        _this.allType3List.forEach(function (val) {
          if (val.restrictFieldValue1 == _this.feedbackFirstCheckData.type2) {
            newType3.push(val);
            if (type3Value != null && type3Value == val.code) {
              existsFlag = true;
            }
          }
        });
        if (!existsFlag && type3Value != null) {
          let newIc = { code: type3Value, chineseValue: type3Value, englishValue: type3Value }
          newType3.push(newIc);
        }
        _this.type3List = newType3;
      }
    },
    saveStoreFeedback: function () {
      //判断校验是否通过
      let that = this;

      if (this.$refs['feedbackDataForm']) {
        this.$refs['feedbackDataForm'].clearValidate();
      }
      if (this.$refs['feedbackComplaintDataForm']) {
        this.$refs['feedbackComplaintDataForm'].clearValidate();
      }
      if (this.$refs['feedbackFirstCheckDataForm']) {
        this.$refs['feedbackFirstCheckDataForm'].clearValidate();
      }
      //只校验货号
      let validFlag = false;
      this.$refs.feedbackDataForm.validateField("materialCode", errMsg => {
        if (!errMsg) {
          validFlag = true;
        }
      });
      if (!validFlag) {
        return;
      }
      this.saveSubmit = 'save';

      /* 保存时不做校验
      let validFlag = false;
      this.$refs['feedbackDataForm'].validate((valid) => {
          validFlag = valid;
      });
      this.$refs['feedbackComplaintDataForm'].validate((valid) => {
          validFlag = valid;
      });
      if (this.showFirstCheck) {
          this.$refs['feedbackFirstCheckDataForm'].validate((valid) => {
              validFlag = valid;
          });
      }
      if(!validFlag){
          return;
      }*/
      let feedbackInfo = {};
      feedbackInfo.method = "save";
      feedbackInfo.feedback = this.feedbackData;
      feedbackInfo.feedbackComplaint = this.feedbackComplaintData;
      if (this.showFirstCheck) {
        feedbackInfo.feedbackFirstCheck = this.feedbackFirstCheckData;
      }
      feedbackInfo.detailDoc = that.detailDocfileList.concat(that.detailDocfileList2);
      feedbackInfo.foreignPic = this.boxPhotofileList2;
      feedbackInfo.questionPic = this.problemProductPhotoList2;
      feedbackInfo.otherPic = this.otherPhotosList2;
      //判断发生赔偿时，赔偿内容必填写

      if (feedbackInfo.feedbackComplaint.haveCompensated == 'Y' &&
        (feedbackInfo.feedbackComplaint.compensateInfo == null || feedbackInfo.feedbackComplaint.compensateInfo.trim() == '')) {
        Message({ message: '请填写赔偿内容！', type: "warning" });
        return;
      }
      this.saveSourceCode();//反馈渠道保存
      // 保存的时候 要 先验证货号是否存在
      if (this.feedbackData.materialCode) {
        storeFeedbackApi.getMaterialInfo(this.feedbackData.materialCode).then((getMaterialRes) => {
          if (getMaterialRes.meta.success) {
            //保存
            storeFeedbackApi.saveFeedbackInfo(feedbackInfo).then((res) => {
              if (res.code == '200') {
                //清空请详细描附件以免数据重复
                if (this.$refs.upload != undefined) {
                  this.$refs.upload.clearFiles();
                }

                that.detailDocfileList2 = [];
                Message({ message: this.$t('common.saveSuccess'), type: "success" });
                //将返回的主键写回对象(多个对象的主键)或者重新获取当前页面数据
                this.storeFeedbackPageInitM(res.data);
              } else {
                Message(res.msg);
              }
            })
          } else {
            Message({ message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist') + this.$t('common.Reenter'), type: "warning" });
          }
        })
      } else {
        //保存
        storeFeedbackApi.saveFeedbackInfo(feedbackInfo).then((res) => {
          if (res.code == '200') {
            //清空请详细描附件以免数据重复
            if (this.$refs.upload != undefined) {
              this.$refs.upload.clearFiles();
            }

            that.detailDocfileList2 = [];
            Message({ message: this.$t('common.saveSuccess'), type: "success" });
            //将返回的主键写回对象(多个对象的主键)或者重新获取当前页面数据
            this.storeFeedbackPageInitM(res.data);
          } else {
            Message(res.msg);
          }
        })
      }

    },
    saveStoreFeedbackMCD: function (method) {
      let _this = this;
      _this.saveSubmit = 'submit';
      //判断校验是否通过
      let validFlag = false;
      _this.$refs['feedbackFirstCheckDataForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      //保存前判断是否选择了CQS变更原因  *
      if ('submit' == method) {
        if (_this.cqsChange.cqsChangeRemarks == null || _this.cqsChange.cqsChangeRemarks.trim() == '') {
          Message({ message: '请填写CQS变更原因！', type: "warning" });
          return;
        }
        this.saveSourceCode();//反馈渠道保存
        // _this.feedbackFirstCheckData.cqsChangeReason = _this.cqsChange.cqsChangeReason;
        _this.feedbackFirstCheckData.cqsChangeRemarks = _this.cqsChange.cqsChangeRemarks;
        _this.feedbackFirstCheckData.sourceCode = this.feedbackData.sourceCode;
        storeFeedbackApi.saveFeedbackInfoMCD(_this.feedbackFirstCheckData).then((res) => {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
          _this.showCqsChangeReasonDialog = false;
          //保存成功后重新设置比较值
          _this.oldFirstCheckType = _this.feedbackFirstCheckData.type1 + _this.feedbackFirstCheckData.type2 +
            _this.feedbackFirstCheckData.type3 + _this.feedbackFirstCheckData.type2 +
            _this.feedbackFirstCheckData.problemLevel + _this.feedbackFirstCheckData.relateType +
            _this.feedbackData.sourceCode + _this.feedbackFirstCheckData.firstCheckDcId + _this.feedbackFirstCheckData.cc;
          _this.storeFeedbackPageInitM(_this.$route.query.feedbackId);
        })
      } else {
        //判断修改后的单据与旧单据是否不同
        let newType = _this.feedbackFirstCheckData.type1 + _this.feedbackFirstCheckData.type2 +
          _this.feedbackFirstCheckData.type3 + _this.feedbackFirstCheckData.type2 +
          _this.feedbackFirstCheckData.problemLevel + _this.feedbackFirstCheckData.relateType +
          _this.feedbackData.sourceCode + _this.feedbackFirstCheckData.firstCheckDcId + _this.feedbackFirstCheckData.cc;
        if (_this.oldFirstCheckType == newType) {
          Message({ message: '请进行初检信息变更后再进行保存', type: "warning" });
          return;
        }
        //展示原变更信息
        let cqsChangeData = {
          // cqsChangeReason:_this.feedbackFirstCheckData.cqsChangeReason,//变更原因
          cqsChangeRemarks: _this.feedbackFirstCheckData.cqsChangeRemarks//变更备注
        }
        _this.cqsChange = cqsChangeData;
        _this.showCqsChangeReasonDialog = true;
      }
    },
    submitStoreFeedback: function () {
      let _this = this;
      let roles = JSON.parse(localStorage.getItem("ms_roles"));
      this.saveSubmit = 'submit';
      //判断校验是否通过
      let validFlag1 = false;
      let validFlag2 = false;
      let validFlag3 = false;
      this.$refs['feedbackDataForm'].validate((valid) => {
        validFlag1 = valid;
      });
      this.$refs['feedbackComplaintDataForm'].validate((valid) => {
        validFlag2 = valid;
      });
      if (this.showFirstCheck) {
        this.$refs['feedbackFirstCheckDataForm'].validate((valid) => {
          validFlag3 = valid;
        });
        if (!validFlag1 || !validFlag2 || !validFlag3) {
          return;
        }
      } else if (!validFlag1 || !validFlag2) {
        return;
      }
      let feedbackInfo = {};
      feedbackInfo.method = "submit";
      feedbackInfo.feedback = this.feedbackData;
      feedbackInfo.feedbackComplaint = this.feedbackComplaintData;
      if (this.showFirstCheck) {
        feedbackInfo.feedbackFirstCheck = this.feedbackFirstCheckData;
      }
      //feedbackInfo.detailDoc=this.detailDocfileList2;
      feedbackInfo.detailDoc = this.detailDocfileList.concat(this.detailDocfileList2);
      feedbackInfo.foreignPic = this.boxPhotofileList2;
      feedbackInfo.questionPic = this.problemProductPhotoList2;
      feedbackInfo.otherPic = this.otherPhotosList2;

      //反馈中心创建的单据不用要求图片一定上传
      if (_this.reportType != 'FBC') {
        //外箱照片,问题产品照片
        if (feedbackInfo.foreignPic.length == 0) {
          Message({ message: '请上传外箱照片！', type: "warning" });
          return;
        }
        if (feedbackInfo.questionPic.length == 0) {
          Message({ message: '请上传问题产品照片！', type: "warning" });
          return;
        }
      }
      if (feedbackInfo.feedbackComplaint.haveCompensated == 'Y' &&
        (feedbackInfo.feedbackComplaint.compensateInfo == null || feedbackInfo.feedbackComplaint.compensateInfo.trim() == '')) {
        Message({ message: '请填写赔偿内容！', type: "warning" });
        return;
      }
      this.saveSourceCode();//反馈渠道保存
      if (roles.indexOf('SF_FBC_BASIC') !== -1) {
        storeFeedbackApi.checkIsRepeat(feedbackInfo).then(res => {
          console.log('res', res);
          if (res.code === '200') {
            if (res.data) {
              this.emailDialogVisible = true
            } else {
              this.sendReq(feedbackInfo)
            }
          } else {
            Message({ message: res.msg, type: "error" });
          }
        })
      } else {
        this.sendReq(feedbackInfo)
      }
    },
    isSend(val) {
      console.log("🚀 ~ file: storeFeedbackDetail.vue:1762 ~ isSend ~ val:", val)
      let feedbackInfo = {};
      feedbackInfo.method = "submit";
      feedbackInfo.feedback = this.feedbackData;
      feedbackInfo.feedbackComplaint = this.feedbackComplaintData;
      if (this.showFirstCheck) {
        feedbackInfo.feedbackFirstCheck = this.feedbackFirstCheckData;
      }
      feedbackInfo.feedbackFirstCheck.isSendRepeatEmail = this.isSendRepeatEmail
      feedbackInfo.feedbackFirstCheck.isUpgradeLevel = this.isUpgradeLevel
      feedbackInfo.detailDoc = this.detailDocfileList.concat(this.detailDocfileList2);
      feedbackInfo.foreignPic = this.boxPhotofileList2;
      feedbackInfo.questionPic = this.problemProductPhotoList2;
      feedbackInfo.otherPic = this.otherPhotosList2;
      this.sendReq(feedbackInfo)
    },
    sendReq(feedbackInfo) {
      let _this = this;
      //先验证货号是否存在
      storeFeedbackApi.getMaterialInfo(this.feedbackData.materialCode).then((getMaterialRes) => {
        if (getMaterialRes.meta.success) {
          storeFeedbackApi.saveFeedbackInfo(feedbackInfo).then((res) => {
            if (res.code == '200') {
              //清空请详细描附件以免数据重复
              if (_this.$refs.upload != undefined) {
                _this.$refs.upload.clearFiles();
              }
              _this.detailDocfileList2 = [];
              _this.disableEditor = true;
              _this.disableEditorFirstCheck = true;
              _this.disableEditorFirstCheckMcd = true;
              _this.disableEditorSourceCode = true;
              _this.saveBtnShow = false;
              _this.submitBtnShow = false;
              _this.returnBtnShow = false;
              this.emailDialogVisible = false
              this.storeFeedbackPageInitM(res.data);
              //判断是不是门店提交
              if (feedbackInfo.feedback.reportType == 'STORE' && (feedbackInfo.feedback.status == 'draft' || feedbackInfo.feedback.status == 'return')) {
                let alertMsg = "亲爱的餐厅伙伴，" +
                  "<br\/>已收到您提交的餐厅质量反馈，我们会在最晚5个工作日内进行调查回复。您可以登陆系统，保持关注。" +
                  "<br\/>如涉及异物投诉，请餐厅保存好异物，等待后续通知。";
                Message({ dangerouslyUseHTMLString: true, showClose: true, message: alertMsg, duration: 30000, type: "success" });
              } else {
                Message({ message: this.$t('common.submitSuccess'), type: "success" });
              }
            } else {
              Message(res.msg);
            }
          })
        } else {
          Message({ message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist') + this.$t('common.Reenter'), type: "warning" });
        }
      })
    },
    emailClose() {
      this.isSendRepeatEmail = 'Y'
      this.isUpgradeLevel = 'Y'
      this.emailDialogVisible = false
    },
    returnStoreFeedback() {
      let that = this;
      let promise = null;
      let feedback = this.feedbackData;
      let option = {
        confirmButtonText: that.$t("common.confirm"),
        cancelButtonText: that.$t("common.cancel"),
        customClass: 'colorBtn',
        inputValidator: (val) => {
          if (val === null) {
            return that.$t('storeFeedback.pleaseFillInReturnReason');
          }
          return val.length <= 300
        },
        inputErrorMessage: that.$t("sensory.report.reasonTooLong")
      }
      promise = this.$prompt(that.$t("storeFeedback.pleaseFillInReturnReason"), that.$t("common.return"), option)
      promise.then(res => {
        feedback.returnRemark = res.value;
      }).then(value => {
        that.saveSourceCode();//反馈渠道保存
        //退回
        storeFeedbackApi.feedBackCenterReturn(feedback).then((res) => {
          if (res.meta.success) {
            Message({ message: this.$t('common.operateSuccess'), type: "success" });
            this.historyBack();
          } else {
            Message(res.msg);
          }
        })
      }).catch(reason => {
        console.log(reason);
      })
    },
    saveSourceCode: function () {//修改反馈渠道
      let _this = this;
      //有意义的主键，拥有反馈渠道编辑权限，并且基本信息可不编辑的情况下
      if (!!this.ttFeedbackId && this.ttFeedbackId > 1 && this.haveFeedbacksUpdateSourceCode && this.disableEditor) {
        if (_this.oldSourceCode != _this.feedbackData.sourceCode) {//发生了变更
          if (_this.saveSourceCodeBtnShow) {//只有修改反馈渠道的权限
            if (_this.cqsChange1.cqsChangeRemarks == null || _this.cqsChange1.cqsChangeRemarks.trim() == '') {
              if (!_this.showCqsChangeReasonDialog1) {
                _this.showCqsChangeReasonDialog1 = true;
              } else {
                Message({ message: '请填写CQS变更原因！', type: "warning" });
              }
            } else {
              let newObj = {};
              newObj.ttFeedbackId = _this.feedbackData.ttFeedbackId;
              newObj.sourceCode = _this.feedbackData.sourceCode;
              newObj.sourceCodeReason = _this.cqsChange1.cqsChangeRemarks.trim();
              storeFeedbackApi.saveFeedBackSourceCode(newObj).then((res) => {
                if (_this.saveSourceCodeBtnShow) {
                  Message({ message: this.$t('common.operateSuccess'), type: "success" });
                  _this.showCqsChangeReasonDialog1 = false;
                  _this.oldSourceCode = _this.feedbackData.sourceCode;
                }
              }).catch((error) => {
                //文件上传失败
                Message({ message: '反馈渠道修改失败', type: "error" });
              });
            }
          } else {
            let newObj = {};
            newObj.ttFeedbackId = _this.feedbackData.ttFeedbackId;
            newObj.sourceCode = _this.feedbackData.sourceCode;
            storeFeedbackApi.saveFeedBackSourceCode(newObj).then((res) => {
              _this.oldSourceCode = _this.feedbackData.sourceCode;
            }).catch((error) => {
              //文件上传失败
              Message({ message: '反馈渠道修改失败', type: "error" });
            });
          }
        }
      }
    },
    compensateInfoDisable: function (dFlag) {
      if (dFlag) { return true; }
      //判断是否发生用餐者赔偿
      if ('Y' != this.feedbackComplaintData.haveCompensated) {
        this.feedbackComplaintData.compensateInfo = '';
        return true;
      }
      return false;
    },
    selectBlurType2(e) {
      let incArr = new Array()
      this.type2List.forEach(item => {
        incArr.push(item.chineseValue);
        incArr.push(item.englishValue);
      });
      if (!!e.target.value && incArr.indexOf(e.target.value) == -1) {
        this.feedbackFirstCheckData.isRepeat = 'N';
        let newIc = { code: e.target.value, chineseValue: e.target.value, englishValue: e.target.value }
        this.type2List.push(newIc);
        this.feedbackFirstCheckData.type2 = e.target.value;
      }
      this.getType3Option();
      this.changeType2();
    },
    selectBlurType3(e) {
      let incArr = new Array()
      this.type3List.forEach(item => {
        incArr.push(item.chineseValue);
        incArr.push(item.englishValue);
      });
      if (!!e.target.value && incArr.indexOf(e.target.value) == -1) {
        let newIc = { code: e.target.value, chineseValue: e.target.value, englishValue: e.target.value }
        this.type3List.push(newIc);
        this.feedbackFirstCheckData.type3 = e.target.value;
      }
    },
    selectBlurSourceCode(e) {
      let scArr = new Array()
      this.sourceCodeList.forEach(item => {
        scArr.push(item.chineseValue);
        scArr.push(item.englishValue);
      })
      if (!!e.target.value && scArr.indexOf(e.target.value) == -1) {
        let newIc = { code: e.target.value, chineseValue: e.target.value, englishValue: e.target.value }
        this.sourceCodeList.push(newIc);
        this.feedbackData.sourceCode = e.target.value;
      }
    },
    selectMaterialMethod: function (material) {
      let _this = this;
      if (commonFun.isNotEmpty(material)) {
        _this.feedbackData.materialCode = material.eightBitCode;
        _this.feedbackData.materialName = material.eightBitCodeName;
        _this.feedbackData.supplierName = material.plantName;
        _this.feedbackData.tmSupplierId = material.tmPlantId;
        _this.$refs.feedbackDataForm.validateField('materialCode');
        if (_this.feedbackData.reportType == 'FBC') {
          _this.feedbackFirstCheckData.isLto = material.isLto;
        }
        _this.changeMaterialCode(material.eightBitCode)
      } else {
        _this.feedbackData.materialCode = "";
        _this.feedbackData.materialName = "";
        _this.feedbackData.supplierName = "";
        _this.feedbackData.tmSupplierId = "";
      }
      this.showSelMaterialDialog = false;
      this.checkRepeatMethod();
    },
    selectDataBefore: function (fieldName) {
      let _this = this;
      if (_this.feedbackData[fieldName] == " ") {
        _this.feedbackData[fieldName] = null;
      }
    },
    handleBoxPhotoPreview(file) {
      console.log("GY🚀 ~ handleBoxPhotoPreview ~ file:", file);
      this.boxPhotoImageUrl = file.url;
      this.boxPhotoDialogVisible = true;
    },
    handleProblemProductPreview(file) {
      this.problemProductImageUrl = file.url;
      this.problemProductDialogVisible = true;
    },
    handleOtherPhotosPreview(file) {
      this.otherPhotosImageUrl = file.url;
      this.otherPhotosDialogVisible = true;
    },
    checkRepeatMethod: function () {
      let _this = this;
      let param = {};
      param.ttFeedbackId = this.ttFeedbackId;
      param.materialCode = this.feedbackData.materialCode;
      param.productionDate = this.feedbackData.productionDate;
      if (!!param.productionDate) {
        param.productionDate = param.productionDate.substring(0, 10);
      }
      param.type2 = this.feedbackFirstCheckData.type2;

      if (!!param.ttFeedbackId && !!param.materialCode && !!param.type2) {
        storeFeedbackApi.checkRepeat(param).then((res) => {
          if (res.meta.success) {
            _this.feedbackFirstCheckData.isRepeat = res.data;
          } else {
            Message(res.msg);
          }
        })
      } else {
        _this.feedbackFirstCheckData.isRepeat = 'N';
      }
    },
    saveFcRemarks: function () {
      let newObj = {};
      newObj.ttFeedbackId = this.feedbackData.ttFeedbackId;
      newObj.fcRemarks = this.feedbackData.fcRemarks.trim();
      storeFeedbackApi.saveFcRemarks(newObj).then((res) => {
        Message({ message: this.$t('common.operateSuccess'), type: "success" });
      }).catch((error) => {
        //文件上传失败
        Message({ message: '质量反馈中心备注修改失败', type: "error" });
      });
    },
    retrieveInOutPackUnit: function (materialCode) {
      let _this = this;
      storeFeedbackApi.getMaterialInfo(materialCode).then((res) => {
        if (res.meta.success) {
          _this.renderInOutPackUnit(res.data);
        } else {
          Message({ message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), type: "warning" });
        }
      })
    },
    renderInOutPackUnit: function (material) {
      let _this = this;
      let bulkUnitValue = (this.icMap['UOM'][material.griUom] || _this.feedbackComplaintData.bulkUnit || '');
      if(!_this.feedbackComplaintData.bulkUnit) {
        _this.feedbackComplaintData.bulkUnit = bulkUnitValue;
      }
      let outerPackUnitValue = (_this.feedbackComplaintData.outerPackUnit || this.icMap['OUTER_PACKAGE_TYPE'][material.productPackagingType] || '');
      let pIdx = outerPackUnitValue.search(/[(（]/);
      if(pIdx > 0) {
        outerPackUnitValue = outerPackUnitValue.substring(0, pIdx);
      }
      _this.feedbackComplaintData.outerPackUnit = outerPackUnitValue;
      if(material.quantityUomOutsourceNum) {
        outerPackUnitValue += "（"  + material.quantityUomOutsourceNum + bulkUnitValue + "）";
      }
      _this.outerPackUnitValue = outerPackUnitValue;

      if(material.isInnerPacking == 'Y') {
        _this.disableInnerPack = false;
        let innerPackUnitValue = (_this.feedbackComplaintData.innerPackUnit || this.icMap['INNER_PACKAGE_TYPE'][material.innerPackingType] || '');
        pIdx = innerPackUnitValue.search(/[(（)]/);
        if(pIdx > 0) {
          innerPackUnitValue = innerPackUnitValue.substring(0, pIdx);
        }
        _this.feedbackComplaintData.innerPackUnit = innerPackUnitValue;
        if(material.quantityUomInnerNum) {
          innerPackUnitValue += "（"  + material.quantityUomInnerNum + bulkUnitValue + "）";
        }
        _this.innerPackUnitValue = innerPackUnitValue;
      } else {
        _this.disableInnerPack = true;
        _this.feedbackComplaintData.innerPackNum = '';
        _this.innerPackUnitValue = '';
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE"] = "TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE";
      mapObj["TM_MATERIAL_RECORD:INNER_PACKING_TYPE"] = "TM_MATERIAL_RECORD:INNER_PACKING_TYPE";
      mapObj["TM_FIVE_BIT_CODE:UOM"] = "TM_FIVE_BIT_CODE:UOM";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.icMap['OUTER_PACKAGE_TYPE'] = commonFun.convertToIcMap(res["TM_MATERIAL_RECORD:PRODUCT_PACKAGING_TYPE"]);
        this.icMap['INNER_PACKAGE_TYPE'] = commonFun.convertToIcMap(res["TM_MATERIAL_RECORD:INNER_PACKING_TYPE"]);
        this.icMap['UOM'] = commonFun.convertToIcMap(res["TM_FIVE_BIT_CODE:UOM"]);
      });
    }
  }
};
</script>
<style  lang="scss">
.hide .el-upload--picture-card {
  display: none;
}

.searchBox_top {
  margin-bottom: 20px;
}

.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}

.enlargePhoto {
  z-index: 3000 !important;

  .el-dialog {
    width: 90%;
    margin-top: 10px;
  }
}

.storeFeedbackApplicationAdd .el-card {
  border-radius: 0;
}

// .storeFeedbackApplicationAdd .el-tooltip__popper{
//     z-index:1800;
// }
</style>
<style scoped lang="scss">
// .handle-input{
//     width: 85%;
// }
.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.nodeList {
  margin-bottom: 20px;
}

.ccTip {
  font-size: 12px;
  color: #f56c6c;
}

/deep/ .unit__uom .el-input-group__append {
  padding: 0 6px !important;
}
</style>
